import React from "react";
import { PALETTE } from "../ThemeConstants";
import { Col } from "react-bootstrap";

export default function DetailCol({
  mainText,
  secondaryText,
  paddingLeft = false,
  paddingRight = false,
  background = PALETTE.LIGHTGRAY,
  my = false,
}) {
  const pLeft = paddingLeft ? 5 : 0;
  const pRight = paddingRight ? 5 : 0;
  return (
    <Col
      className={`text-center m-auto ${my ? "my-1" : ""}`}
      style={{ paddingLeft: pLeft, paddingRight: pRight }}
    >
      <div
        className="text-center align-self-center shadow-sm rounded-md p-3 m-auto"
        style={{
          width: "100%",
          background: background,
        }}
      >
        <p style={{ fontWeight: "bold", marginBottom: 3 }}>{mainText}</p>
        <p className="my-0" style={{ color: PALETTE.GRAY }}>
          {secondaryText}
        </p>
      </div>
    </Col>
  );
}
